import { render } from "./StripeConnectReturn.vue?vue&type=template&id=e60c6778&scoped=true"
import script from "./StripeConnectReturn.vue?vue&type=script&lang=js"
export * from "./StripeConnectReturn.vue?vue&type=script&lang=js"

import "./StripeConnectReturn.vue?vue&type=style&index=0&id=e60c6778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60c6778"]])

export default __exports__